import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function TransactionHistory({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M2.76211 6.66691L2.52807 7.07228L1.96856 4.98418L0.680664 5.32927L1.65673 8.97201C1.75203 9.32765 2.11758 9.5387 2.47323 9.44341L6.11596 8.46734L5.77087 7.17944L3.68277 7.73895L3.96808 7.24477L3.96736 7.24435C5.59445 4.50232 8.58326 2.66665 12.0001 2.66665C17.1547 2.66665 21.3334 6.84532 21.3334 12C21.3334 17.1546 17.1547 21.3333 12.0001 21.3333C6.8454 21.3333 2.66672 17.1546 2.66672 12H1.33339C1.33339 17.891 6.10902 22.6666 12.0001 22.6666C17.8911 22.6666 22.6667 17.891 22.6667 12C22.6667 6.10894 17.8911 1.33331 12.0001 1.33331C8.05105 1.33331 4.60412 3.47963 2.76081 6.66616L2.76211 6.66691Z"
        fill={iconColor}
      />
      <Path
        d="M10.6667 4.99998H12.0001V12H17.0001V13.3333H10.6667V4.99998Z"
        fill={iconColor}
      />
    </Svg>
  );
}
